var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_c('h1',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/images/logo.svg"),"alt":"logo"}}),_c('span',[_vm._v(_vm._s(_vm.$t('Baatein91')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }